module.exports = __webpack_public_path__ + "static/media/4.78b7e36e.svg";